import { render, staticRenderFns } from "./EmployeesAboutToUpgradeBonus.vue?vue&type=template&id=3fb494bb&scoped=true"
import script from "./EmployeesAboutToUpgradeBonus.vue?vue&type=script&lang=js"
export * from "./EmployeesAboutToUpgradeBonus.vue?vue&type=script&lang=js"
import style0 from "./EmployeesAboutToUpgradeBonus.vue?vue&type=style&index=0&id=3fb494bb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fb494bb",
  null
  
)

export default component.exports